<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div
          class="tabElement stock active"
          @click="changeTab('stock')"
        >
          <span class="material-icons-sharp"> app_registration </span>En attente
          d'entrée en stock
        </div>
        <div class="tabElement contrat " @click="changeTab('contrat')">
          <span class="material-icons-sharp"> app_registration </span>Retour
          stock
        </div>
      </div>
</div>
      <div id="stockTab" class="tabElementContent active">
        <!-- <div @click="addNewBl" class="buttonAdd">
            <span> Ajouter un Bl</span>
          </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderConteneur" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <img v-if="contenuerAllData.length == 0" src="../assets/empty3.png" alt="" />
            <tbody v-else>
              <tr
                @click="editeConteneurRow(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in contenuerAllData"
                :key="item._id"
              >

                <td>{{ item.name }}</td>
                <td>{{ item.containType ? item.containType.name : "" }}</td>
                <td>{{ item.product ? item.product.name : "" }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.store ? item.store.name : "" }}</td>
                <td>{{ item.observation }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="contratTab" class="tabElementContent ">
        <!-- <div @click="addNewReturnStock" class="buttonAdd">
          <span> Enregistrer une reprise de stock </span>
        </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <img v-if="returnStockData.length == 0" src="../assets/empty3.png" alt="" />
            <tbody v-else>
              <tr
                @click="editeReturnStockRow(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in returnStockData"
                :key="item._id"
              >
              <td>
                  {{ item.status}}
                </td>
                <td>
                  {{ item.product.name }}
                </td>
                <td>
                  {{ item.quantity }}
                </td>
                <td>
                  {{ item.customer.name }}
                </td>
                <td>
                  {{ item.observation }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment"
export default {
  name: "stockEnter",
  components: {},
  data: () => ({

    isSelecteds: [],
    isSelectedAll: false,
    tableHeader: [
      "Statut",
      "Désignation produit",
      "Quantité",
      "Client",
      "Observation",
    ],
    tableHeaderConteneur: [
      "Désignation",
      "Type de conteneur",
      "Produit",
      "Quantité attendue",
      "Magasin",
      "Observation",
    ],
   
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
  },
  computed: {
    ...mapGetters([
    //   "contratData",
    //   "blData",
    //   "conteneurData",
      "contenuerAllData",
      "returnStockData",
    //   "storeData",
    ]),
  },
  async mounted() {
    await this.getConteneurAll({ alreadyInStock: "Oui",haveAcknowledgeReceiptDate: "Non" });
  },
  methods: {
    ...mapActions([
    //   "getContrat",
    //   "getSupplier",
    //   "getContratDetails",
    //   "getBl",
    //   "getConteneur",
      "getConteneurAll",
      "getReturnToStock",
      "getCustomerList",
      "getStore",
      "getProduct"
    //   "getTransitaire",
    //   "getStore",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async editeConteneurRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.contenuerAllData.length; i++) {
          this.contenuerAllData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log("OK", item);
        const d = new Date();

        await this.getProduct({})
        const value = {
          _id: item._id,
          modalType: "enterProductInStock",
          quantity: item.quantity,
          containType: item.containType ? item.containType.name : "",
          store: item.store ? item.store.name : "",
          contractDetail: item.contractDetail ? item.contractDetail.number : "",
          name: item.name,
          bl: item.bl ? item.bl.number : "",
          product: item.product ? item.product.name : "",
          productId: item.product ? item.product._id : "",
          outDate: item.outDate,
          transitaire: item.transitaire ? item.transitaire.fullName : "",
          transitaireAmount: item.transitaireAmount,
          amount: item.amount,
          acknowledgeReceiptDate: moment(d).format('YYYY-MM-DD'),
        };
        console.log("--------------------------------",value);
        this.$emit("editeRowForDash", {
          name: "enterProductInStock",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeReturnStockRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.returnStockData.length; i++) {
          this.returnStockData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.returnStockData);
        await this.getProduct({});
        await this.getStore({});
        await this.getCustomerList({});
        const value = {
          _id: item._id,
          modalType: "editeReturnStockRowMagasin",
          product: item.product ? item.product.name : "",
          store: item.store ? item.store.name : "",
          customer: item.customer ? item.customer.name : "",
          quantity: item.quantity,
          amount: item.amount,
          observation: item.observation,
        };
        this.$emit("editeRowForDash", {
          name: "editeReturnStockRowMagasin",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show",true)
      this.$emit("closeAllModal");
      if (tabName === "stock") {
        await this.getConteneurAll({ alreadyInStock: "Oui",haveAcknowledgeReceiptDate: "Non" });
      }else if (tabName === "contrat"){
        await this.getReturnToStock({});
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
  